$(document).ready(function () {
	init();
	$(window).trigger('resize');
	$(window).trigger('scroll');
});

function init() {
	// Get the gclid parameter from the url
	getGclidParameter();

	// Append gclid to links on the same domain that open in a new tab
	appendLinksWithGclid();

	// Append Radisson links with gclid
	appendRadissonLinksWithGclid();

	initFAQs();

	//Lazyload Images
	$(window).on('load scroll resize', function () {
		$('.js__lazyload:visible').each(function () {
			if (isVisible($(this))) {
				if ($(this).data('srcset')) {
					$(this).attr('srcset', $(this).data('srcset'));
					$(this).removeAttr('data-srcset');
				}

				if ($(this).data('src')) {
					$(this).attr('src', $(this).data('src'));
					$(this).removeAttr('data-src');
				}

				if ($(this).data('bg-image')) {
					var imageUrl = $(this).data('bg-image');
					var mobileImageUrl = $(this).data('bg-image-mobile');
					if (mobileImageUrl && $(window).width() < 768) {
						imageUrl = mobileImageUrl;
					}
					$(this).css('background-image', 'url(' + imageUrl + ')');
					$(this).removeAttr('data-bg-image').removeAttr('data-bg-image-mobile');
				}
			}
		});
	});

	function isVisible(elem) {
		var scrollTop = $(window).scrollTop();
		var windowBottom = scrollTop + $(window).height();
		var offset = 100;
		var elementTop = elem.offset().top;

		if (windowBottom + offset > elementTop) {
			return true;
		} else {
			return false;
		}
	}

	//Sticky nav on scroll
	$(window).on('scroll resize', function () {
		var scrollElem;

		if ($('.m__check-availability').length) {
			scrollElem = $('.m__check-availability');
		} else if ($('.m__full-width-video').length) {
			scrollElem = $('.m__full-width-video');
		} else {
			scrollElem = $('.m__full-width-image.module-1');
		}

		var scrollTop = $(window).scrollTop();
		var elemBottom = scrollElem.offset().top + scrollElem.outerHeight();

		if (scrollTop >= elemBottom) {
			$('.m__header').addClass('scrolled');
		} else {
			$('.m__header').removeClass('scrolled');
		}
	});

	// Header Scripts
	$('.menu-toggle').click(function (e) {
		e.preventDefault();

		if (!$(this).hasClass('open')) {
			// hamburger showing
			$(this).addClass('open');
			$('.main-menu-overlay').addClass('active');
			$('html, body, div#container').addClass('no-scroll');
			$('header').addClass('fixed');
			$('.header-small-nav-section .nav').addClass('hide-nav');
		} else {
			// Close icon showing
			if (!$('.reservations-overlay').hasClass('active')) {
				// reservations overlay not active
				$('.main-menu-overlay').removeClass('active');
				$(this).removeClass('open');
				$('html, body, div#container').removeClass('no-scroll');
				$('header').removeClass('fixed');
				$('.header-small-nav-section .nav').removeClass('hide-nav');
			} else {
				// reservations overlay is active
				if ($('.main-menu-overlay').hasClass('active')) {
					// if main menu overlay is also active
					$('.reservations-overlay').removeClass('active'); // only hide reservations overlay to show main menu
					$('header').removeClass('reservations-active');
				} else {
					// main menu overlay isn't active but reservation is
					$('.reservations-overlay').removeClass('active');
					$('header').removeClass('reservations-active');
					$('.menu-toggle').removeClass('open');
					$('html, body, div#container').removeClass('no-scroll');
					$('header').removeClass('fixed');
					$('.header-small-nav-section .nav').removeClass('hide-nav');
				}
			}
		}
	});

	$('.reservations-toggle').click(function (e) {
		e.preventDefault();

		if (
			!$('.reservations-overlay').hasClass('active') &&
			!$('.main-menu-overlay').hasClass('active')
		) {
			// Nothings open
			$('.reservations-overlay').addClass('active');
			$('header').addClass('reservations-active');
			$('.menu-toggle').addClass('open');
			$('html').addClass('no-scroll');
			$('.header-small-nav-section .nav').addClass('hide-nav');
		} else if (
			!$('.reservations-overlay').hasClass('active') &&
			$('.main-menu-overlay').hasClass('active')
		) {
			// Main Menu overlay is active and Reservations overlay isn't
			$('.reservations-overlay').addClass('active');
			$('header').addClass('reservations-active');
		} else if (
			$('.reservations-overlay').hasClass('active') &&
			!$('.main-menu-overlay').hasClass('active')
		) {
			// Reservations overlay is active and Main Menu overlay isn't
			$('.reservations-overlay').removeClass('active');
			$('header').removeClass('reservations-active');
			$('.menu-toggle').removeClass('open');
			$('html').removeClass('no-scroll');
			$('.header-small-nav-section .nav').removeClass('hide-nav');
		} else if (
			$('.reservations-overlay').hasClass('active') &&
			$('.main-menu-overlay').hasClass('active')
		) {
			// Both Reservations and Main Menu overlays are active
			$('.reservations-overlay').removeClass('active');
			$('header').removeClass('reservations-active');
		}
	});

	//Scroll to correct room
	function getUrlVars() {
		var vars = [],
			hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}

		return vars;
	}

	var roomQueryString = getUrlVars()['room-id'];

	if (window.location.href.indexOf(roomQueryString) > -1) {
		var room = $('#room-' + roomQueryString);

		window.onload = function () {
			$('body, html').animate(
				{
					scrollTop: room.offset().top - $('header').outerHeight(),
				},
				750
			);
		};
	}

	// Check Availability
	$('select#rateSearch').on('change', function (e) {
		var form = $(this).closest('form');
		var selected = $(this).find(':selected');
		var codeType = selected.data('code-type');

		if (codeType != '') {
			form.find('input#code').attr('name', codeType);
		} else {
			form.find('input#code').removeAttr('name');
		}
	});

	//Add another room
	$('.js__additional-add-rooms-trigger').on('click', function (e) {
		e.preventDefault();

		var parentElem = $(this).closest('.guests-container');
		var container = parentElem.find('.rooms-popup');
		var numRoomsElem = container.find('.room-counter__counter p');
		var numRooms = parseInt(numRoomsElem.html()) + 1;

		if (numRooms <= 9) {
			// Update the rooms data attribute
			parentElem.find('.js__book-num-rooms').attr('data-rooms', numRooms);

			// Update the popup rooms number indicator
			numRoomsElem.html(numRooms);

			// Show the additional room elem
			container.find('.additional-room.room-' + numRooms).slideDown();

			// Remove the disabled attributes from the adults and childrens fields for this room number
			parentElem.find('#adults-' + numRooms).removeAttr('disabled');
			parentElem.find('#children-' + numRooms).removeAttr('disabled');

			if (numRooms === 2) {
				// Remove the fade out class from the remove trigger
				container.find('.js__additional-remove-rooms-trigger').removeClass('fade-out');
			}

			if (numRooms === 9) {
				// Add the fade out class from this trigger
				$(this).addClass('fade-out');
			}

			calculateOccupancy(parentElem);
		}
	});

	//Reduce num of rooms
	$('.js__additional-remove-rooms-trigger').on('click', function (e) {
		e.preventDefault();

		var parentElem = $(this).closest('.guests-container');
		var container = parentElem.find('.rooms-popup');
		var numRoomsElem = container.find('.room-counter__counter p');
		var numRooms = parseInt(numRoomsElem.html()) - 1;

		if (numRooms >= 1) {
			// Update the rooms data attribute
			parentElem.find('.js__book-num-rooms').attr('data-rooms', numRooms);

			// Update the popup rooms number indicator
			numRoomsElem.html(numRooms);

			// Hide the last room elem
			container.find('.additional-room.room-' + (numRooms + 1)).slideUp();

			// Disable the adults and childrens fields for this room number
			parentElem.find('#adults-' + (numRooms + 1)).val(0);
			parentElem.find('#adults-' + (numRooms + 1)).attr('disabled', true);

			parentElem.find('#children-' + (numRooms + 1)).val(0);
			parentElem.find('#children-' + (numRooms + 1)).attr('disabled', true);

			// Reset the select elems to default values
			$('#popup-adults-' + (numRooms + 1)).val(2);
			$('#popup-children-' + (numRooms + 1)).val(0);

			if (numRooms === 1) {
				$(this).addClass('fade-out');
			}

			if (numRooms === 8) {
				// Remove the fade out class from the add trigger
				container.find('.js__additional-add-rooms-trigger').removeClass('fade-out');
			}

			calculateOccupancy(parentElem);
		}
	});

	//Open booknig popup
	$('.js__rooms-popup-trigger').on('click', function (e) {
		e.preventDefault();

		var popup = $(this).data('popup');

		$('#' + popup).addClass('active');
	});

	//Close booking popup
	$('.js__popup-close').on('click', function (e) {
		e.preventDefault();
		$('.rooms-popup').removeClass('active');
	});

	//Update Adults/Children amount
	$('.m__check-availability .rooms-popup .popup__innner .input-container select').on(
		'change',
		function (e) {
			var parentElem = $('.m__check-availability .guests-container');
			var hiddenField = $(this).data('field');
			var value = $(this).val();

			$('.m__check-availability #' + hiddenField).val(value);
			updateOptions(e.target);

			calculateOccupancy(parentElem);
		}
	);

	$('.reservations-overlay .rooms-popup .popup__innner .input-container select').on('change', function (e) {
		var parentElem = $('.reservations-overlay .guests-container');
		var hiddenField = $(this).data('field');
		var value = $(this).val();

		$('.reservations-overlay #' + hiddenField).val(value);
		console.log($('.reservations-overlay #' + hiddenField).val(value));

		calculateOccupancy(parentElem);
	});

	function updateOptions(selectElement) {
		const roomDiv = selectElement.closest('.row');
		const isAdultSelect = selectElement.name.includes('adults');
		const selectedValue = parseInt(selectElement.value);

		let correspondingSelect;
		let maxValue = 8 - selectedValue;

		if (isAdultSelect) {
			correspondingSelect = roomDiv.querySelector('[name*="children"]');
		} else {
			correspondingSelect = roomDiv.querySelector('[name*="adults"]');
		}

		// Iterate over all options in the corresponding select box
		for (let i = 0; i < correspondingSelect.options.length; i++) {
			const option = correspondingSelect.options[i];
			if (parseInt(option.value) > maxValue) {
				option.classList.add('hidden');
			} else {
				option.classList.remove('hidden');
			}
		}

		// If the selected number of the corresponding select exceeds the new max, reset to maxValue
		if (parseInt(correspondingSelect.value) > maxValue) {
			correspondingSelect.value = maxValue;
		}
	}

	//Submit the form!
	$('.form-submit-btn').on('click', function (e) {
		e.preventDefault();

		var bookingForm = $(this).closest('form');

		var action = bookingForm.attr('action');
		var searchArray = bookingForm.serializeArray();

		var searchString = '';
		var childrenCount = 0;

		$.each(searchArray, function (key, value) {
			var excludedNames = [
				'popup-adults-1',
				'popup-adults-2',
				'popup-adults-3',
				'popup-adults-4',
				'popup-adults-5',
				'popup-adults-6',
				'popup-adults-7',
				'popup-adults-8',
				'popup-adults-9',
				'popup-children-1',
				'popup-children-2',
				'popup-children-3',
				'popup-children-4',
				'popup-children-5',
				'popup-children-6',
				'popup-children-7',
				'popup-children-8',
				'popup-children-9',
			];

			var isLastElement = key == searchArray.length - 1;

			if (!excludedNames.includes(value.name)) {
				if (value.name == 'children[]') {
					childrenCount = parseInt(value.value);
					var name = value.name.replace('[]', '%5B%5D');
					searchString += name + '=' + value.value;
					
					// Always add aoc parameter, but only add ages if there are children
					if (childrenCount > 0) {
						// Add ages immediately after children parameter
						var ages = Array(childrenCount).fill('6').join(',');
						searchString += `&aoc%5B%5D=${ages}`;
					} else {
						searchString += '&aoc%5B%5D=';
					}
					searchString += '&';
				} else if (value.name == 'adults[]') {
					var name = value.name.replace('[]', '%5B%5D');
					searchString += name + '=' + value.value + '&';
				} else {
					if (isLastElement) {
						searchString += value.name + '=' + value.value;
					} else {
						searchString += value.name + '=' + value.value + '&';
					}
				}
			}
		});

		const abTestData = getAbTestCookieData();
		let abTestString = '';

		if (abTestData) {
			if (abTestData.value === 1) {
				abTestString = `&icid=vwopph-${abTestData.campaignId}control1`;
			} else {
				const variationNumber = abTestData.value - 1;
				abTestString = `&icid=vwopph-${abTestData.campaignId}variation${variationNumber}`;
			}
		}

		var bookingUrl = `${action}${searchString}&rhgext=Qm9PSty6s3HG${abTestString}`;

		// if the gclid parameter exists, add it to the booking url
		if (sessionStorage.getItem('gclid')) {
			bookingUrl += `&gclid=${sessionStorage.getItem('gclid')}`;
		}

		// Check if the modal from VWO exists, if so show the modal and then redirect the user otherwise submit the form as normal
		var modalOverlay = document.getElementById('redirect-modal-overlay');

		if (modalOverlay) {
			// Show the modal overlay (loading screen)
			if (modalOverlay) {
				modalOverlay.style.display = 'block';
			}
			
			setTimeout(() => {
				if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
					// Safari browser
					modalOverlay.style.display = 'none';
				}

				window.location.href = bookingUrl;
			}, 3000); // Adjust delay as needed for the loading screen
			return;
		} else {
			// No VWO modal overlay found, submit the form as normal
			window.location.href = bookingUrl;
		}

	});

	function calculateOccupancy(parentElem) {
		//Init the various vara
		var rooms = 0,
			adults = 0,
			childs = 0;

		//Loop through all possible rooms
		var i = 1,
			iTotal = parentElem.find('.js__book-num-rooms').attr('data-rooms');

		while (i <= iTotal) {
			if (parentElem.find('#popup-adults-' + i).val() > 0) {
				//This room is occupado!
				rooms++;

				adults = adults + parseInt(parentElem.find('#popup-adults-' + i).val());
				childs = childs + parseInt(parentElem.find('#popup-children-' + i).val());
			}

			i++;
		}

		//Get the labels right innit!
		var roomsLabel = 'Room',
			adultsLabel = 'Adult',
			childsLabel = 'Child';

		if (rooms > 1) {
			roomsLabel += 's';
		}

		if (adults > 1) {
			adultsLabel += 's';
		}

		if (childs > 1) {
			childsLabel = 'Children';
		}

		//Update the client facing label
		if (rooms > 0) {
			parentElem.find('#book__rooms').html(rooms + ' ' + roomsLabel);
		}

		if (adults > 0) {
			parentElem.find('#book__adults').html(adults + ' ' + adultsLabel);
		} else {
			parentElem.find('#book__adults').html('');
		}

		if (childs > 0) {
			parentElem.find('#book__children').html(childs + ' ' + childsLabel);
		} else {
			parentElem.find('#book__children').html('');
		}
	}

	// Full Width Slider
	const $fullWidthSlider = $('.full-width-slider');

	if ($fullWidthSlider.length) {
		$fullWidthSlider.slick({
			arrows: false,
			dots: true,
			autoplay: true,
			fade: true,
		});
	}

	// Set a flag to indicate the slider is initialized
    $fullWidthSlider.on('init', function(event, slick) {
        $fullWidthSlider.data('slick-initialized', true);
    });

	if ($('body').hasClass('home')) {
		const slideIndex = getSlideIndexFromURL();
		if (!isNaN(slideIndex) && slideIndex >= 0) {
			// Check if the slider is already initialized
			if ($fullWidthSlider.hasClass('slick-initialized')) {
				navigateToSlide($fullWidthSlider, slideIndex);
			} else {
				// Wait until the slider is initialized
				let initAttempts = 0;
				const maxAttempts = 50;
				const checkInterval = 100; // milliseconds

				const initializationCheck = setInterval(function() {
					if ($fullWidthSlider.data('slick-initialized') || initAttempts >= maxAttempts) {
						clearInterval(initializationCheck);
						if ($fullWidthSlider.data('slick-initialized')) {
							navigateToSlide($fullWidthSlider, slideIndex);
						}
					}
					initAttempts++;
				}, checkInterval);
			}
		}
	}

	// Go to specific slide
	function navigateToSlide(slider, index) {
		const slideCount = slider.slick('getSlick').slideCount;
		const targetIndex = index < slideCount ? index : 0;
		slider.slick('slickGoTo', targetIndex, true);
	}

	// Half Width Content Slider
	if ($('.js__half-width-content-slider').length) {
		var arrow = '/wp-content/themes/vondelpark/library/images/icons/btn-arrow-white.svg';

		$slick_slider = $('.js__half-width-content-slider');
		settings = {
			mobileFirst: true,
			dots: false,
			arrows: true,
			swipe: false,
			fade: true,
			nextArrow:
				"<div class='slick-arrow slick-next' style='background-image: url(" +
				arrow +
				");'></div>",
			prevArrow:
				"<div class='slick-arrow slick-prev' style='background-image: url(" +
				arrow +
				");'></div>",
		};
		$slick_slider.slick(settings);
	}

	//Content and Image Slider
	if ($('.js__content-and-image-slider--images').length) {
		var arrow = '/wp-content/themes/vondelpark/library/images/icons/btn-arrow.svg';

		$slick_slider = $('.js__content-and-image-slider--images');
		settings = {
			mobileFirst: true,
			dots: false,
			arrows: true,
			swipe: false,
			fade: true,
			nextArrow:
				"<div class='slick-arrow slick-next' style='background-image: url(" +
				arrow +
				");'></div>",
			prevArrow:
				"<div class='slick-arrow slick-prev' style='background-image: url(" +
				arrow +
				");'></div>",
			asNavFor: '.js__content-and-image-slider--content',
		};
		$slick_slider.slick(settings);
	}
	if ($('.js__content-and-image-slider--content').length) {
		$slick_slider = $('.js__content-and-image-slider--content');
		settings = {
			mobileFirst: true,
			dots: false,
			arrows: false,
			swipe: false,
			fade: true,
		};
		$slick_slider.slick(settings);
	}

	// Image Slider
	if ($('.js__image-slider').length) {
		var arrow = '/wp-content/themes/vondelpark/library/images/icons/btn-arrow.svg';

		$slick_slider = $('.js__image-slider');
		settings = {
			mobileFirst: true,
			dots: false,
			arrows: true,
			swipe: false,
			fade: true,
			nextArrow:
				"<div class='slick-arrow slick-next' style='background-image: url(" +
				arrow +
				");'></div>",
			prevArrow:
				"<div class='slick-arrow slick-prev' style='background-image: url(" +
				arrow +
				");'></div>",
		};
		$slick_slider.slick(settings);
	}

	// Grid Slider - Mobile Only
	if ($('.js__grid-mobile-slider').length) {
		var prevArrow =
			'/wp-content/themes/vondelpark/library/images/icons/grid-slider-arrow-prev.svg';
		var nextArrow =
			'/wp-content/themes/vondelpark/library/images/icons/grid-slider-arrow-next.svg';
		var gmcount = 1;

		$('.js__grid-mobile-slider').each(function (e) {
			$(this).addClass('js__grid-mobile-slider-' + gmcount);

			var $slick_slider = $('.js__grid-mobile-slider-' + gmcount);
			var settings = {
				mobileFirst: true,
				dots: false,
				arrows: false,
				swipe: true,
				centerMode: true,
				centerPadding: '25px',
				responsive: [
					{
						breakpoint: 1399,
						settings: {
							slidesToShow: 3,
							arrows: true,
							nextArrow:
								"<div class='slick-arrow slick-next' style='background-image: url(" +
								nextArrow +
								");'></div>",
							prevArrow:
								"<div class='slick-arrow slick-prev' style='background-image: url(" +
								prevArrow +
								");'></div>",
							centerPadding: '225px',
						},
					},
					{
						breakpoint: 1199,
						settings: {
							slidesToShow: 3,
							arrows: true,
							nextArrow:
								"<div class='slick-arrow slick-next' style='background-image: url(" +
								nextArrow +
								");'></div>",
							prevArrow:
								"<div class='slick-arrow slick-prev' style='background-image: url(" +
								prevArrow +
								");'></div>",
							centerPadding: '200px',
						},
					},
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 3,
							arrows: true,
							nextArrow:
								"<div class='slick-arrow slick-next' style='background-image: url(" +
								nextArrow +
								");'></div>",
							prevArrow:
								"<div class='slick-arrow slick-prev' style='background-image: url(" +
								prevArrow +
								");'></div>",
							centerPadding: '125px',
						},
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 3,
							arrows: true,
							nextArrow:
								"<div class='slick-arrow slick-next' style='background-image: url(" +
								nextArrow +
								");'></div>",
							prevArrow:
								"<div class='slick-arrow slick-prev' style='background-image: url(" +
								prevArrow +
								");'></div>",
							centerPadding: '100px',
						},
					},
					{
						breakpoint: 575,
						settings: {
							slidesToShow: 3,
							arrows: true,
							nextArrow:
								"<div class='slick-arrow slick-next' style='background-image: url(" +
								nextArrow +
								");'></div>",
							prevArrow:
								"<div class='slick-arrow slick-prev' style='background-image: url(" +
								prevArrow +
								");'></div>",
							centerPadding: '75px',
						},
					},
				],
			};

			$slick_slider.slick(settings);

			// reslick only if it's not slick()
			if ($slick_slider.hasClass('mobile_only')) {
				$(window).on('resize', function () {
					if ($(window).width() >= 576) {
						if ($slick_slider.hasClass('slick-initialized')) {
							$slick_slider.slick('unslick');
						}
						return;
					}

					if (!$slick_slider.hasClass('slick-initialized')) {
						return $slick_slider.slick(settings);
					}
				});
			}

			gmcount++;
		});
	}

	// Rooms Grid Slider - Desktop Only
	if ($('.js__rooms-grid-slider').length) {
		var prevArrow =
			'/wp-content/themes/vondelpark/library/images/icons/grid-slider-arrow-prev.svg';
		var nextArrow =
			'/wp-content/themes/vondelpark/library/images/icons/grid-slider-arrow-next.svg';
		var rgcount = 1;

		$('.js__rooms-grid-slider').each(function (e) {
			$(this).addClass('js__rooms-grid-slider-' + rgcount);

			var $slick_slider_rooms_grid = $('.js__rooms-grid-slider-' + rgcount);
			var settings = {
				slidesToShow: 3,
				dots: false,
				arrows: true,
				nextArrow:
					"<div class='slick-arrow slick-next' style='background-image: url(" +
					nextArrow +
					");'></div>",
				prevArrow:
					"<div class='slick-arrow slick-prev' style='background-image: url(" +
					prevArrow +
					");'></div>",
				swipe: true,
				centerMode: true,
				centerPadding: '225px',
				responsive: [
					{
						breakpoint: 1400,
						settings: {
							centerPadding: '200px',
						},
					},
					{
						breakpoint: 1200,
						settings: {
							centerPadding: '125px',
						},
					},
				],
			};

			$slick_slider_rooms_grid.slick(settings);

			// reslick only if it's not slick()
			$(window).on('resize', function () {
				if ($(window).width() <= 991) {
					if ($slick_slider_rooms_grid.hasClass('slick-initialized')) {
						$slick_slider_rooms_grid.slick('unslick');
					}
					return;
				}

				if (!$slick_slider_rooms_grid.hasClass('slick-initialized')) {
					return $slick_slider_rooms_grid.slick(settings);
				}
			});

			rgcount++;
		});
	}

	// Testimonials Slider
	if ($('.js__testimonials-slider').length) {
		var arrow = '/wp-content/themes/vondelpark/library/images/icons/btn-arrow.svg';
		var tscount = 1;

		$('.js__testimonials-slider').each(function () {
			$(this).addClass('js__testimonials-slider-' + tscount);

			var $slick_slider = $('.js__testimonials-slider-' + tscount);
			var settings = {
				mobileFirst: true,
				dots: false,
				arrows: true,
				swipe: false,
				fade: true,
				nextArrow:
					"<div class='slick-arrow slick-next' style='background-image: url(" +
					arrow +
					");'></div>",
				prevArrow:
					"<div class='slick-arrow slick-prev' style='background-image: url(" +
					arrow +
					");'></div>",
				appendArrows: $('.js__testimonials-slider-arrows'),
			};

			$slick_slider.slick(settings);
		});
	}

	if ($('.js__local-area-slider').length) {
		var arrow = '/wp-content/themes/vondelpark/library/images/icons/btn-arrow.svg';
		var lacount = 1;

		$('.js__local-area-slider').each(function (e) {
			$(this).addClass('js__local-area-slider-' + lacount);

			var $slick_slider = $('.js__local-area-slider-' + lacount);
			var settings = {
				mobileFirst: true,
				dots: false,
				arrows: true,
				swipe: false,
				fade: true,
				nextArrow:
					"<div class='slick-arrow slick-next' style='background-image: url(" +
					arrow +
					");'></div>",
				prevArrow:
					"<div class='slick-arrow slick-prev' style='background-image: url(" +
					arrow +
					");'></div>",
			};

			$slick_slider.slick(settings);
		});
	}

	$(
		'.m__half-width-content-block .container .content-col .content-container .attraction'
	).mouseenter(function () {
		var slideID = $(this).data('attraction-id');
		$('.js__local-area-slider').slick('slickGoTo', slideID);
	});

	// Check Availability
	$('.more-options').on('click', function (e) {
		e.preventDefault();

		$(this).parent().parent().parent().siblings('.hidden').slideToggle();
		$(this).find('.icon').toggleClass('rotate');
	});

	// Datepicker
	$('.overlay-check-in').datepicker({
		minDate: 0,
		dateFormat: 'dd/mm/yy',
		altField: '#overlay-check-in-date',
		altFormat: 'yy-mm-dd',
		onSelect: function (dateText, inst) {
			$(this).parent('.input-container').addClass('date-chosen');
			var checkInDate = new Date($('#overlay-check-in-date').val());
			var checkOutDate = new Date($('#overlay-check-out-date').val());
			var newCheckOutDate = new Date(checkInDate);
			newCheckOutDate.setDate(checkInDate.getDate() + 1);

			if (checkInDate >= checkOutDate) {
				$('.overlay-check-out').datepicker('setDate', newCheckOutDate);
			}

			$('.overlay-check-out').datepicker('option', 'minDate', newCheckOutDate);

			$(this).parent('.input-container').removeClass('datepicker-showing');
		},
		onClose: function (dateText, inst) {
			$(this).parent('.input-container').removeClass('datepicker-showing');
		},
	});
	$('.overlay-check-out').datepicker({
		minDate: 0,
		dateFormat: 'dd/mm/yy',
		altField: '#overlay-check-out-date',
		altFormat: 'yy-mm-dd',
		onSelect: function (dateText, inst) {
			$(this).parent('.input-container').addClass('date-chosen');
			$(this).parent('.input-container').removeClass('datepicker-showing');
		},
		onClose: function (dateText, inst) {
			$(this).parent('.input-container').removeClass('datepicker-showing');
		},
	});

	$('.hasDatepicker').on('click', function (e) {
		$(this).parent('.input-container').addClass('datepicker-showing');
	});

	$('.module-check-in').datepicker({
		minDate: 0,
		dateFormat: 'dd/mm/yy',
		altField: '#module-check-in-date',
		altFormat: 'yy-mm-dd',
		onSelect: function (dateText, inst) {
			$(this).parent('.input-container').addClass('date-chosen');
			var checkInDate = new Date($('#module-check-in-date').val());
			var checkOutDate = new Date($('#module-check-out-date').val());
			var newCheckOutDate = new Date(checkInDate);
			newCheckOutDate.setDate(checkInDate.getDate() + 1);

			if (checkInDate >= checkOutDate) {
				$('.module-check-out').datepicker('setDate', newCheckOutDate);
			}

			$('.module-check-out').datepicker('option', 'minDate', newCheckOutDate);
		},
	});
	$('.module-check-out').datepicker({
		minDate: 0,
		dateFormat: 'dd/mm/yy',
		altField: '#module-check-out-date',
		altFormat: 'yy-mm-dd',
		onSelect: function (dateText, inst) {
			$(this).parent('.input-container').addClass('date-chosen');
		},
	});

	// MatchHeight
	$('.js__match-height').matchHeight();
	$('.js__rooms-match-height').matchHeight();
	$('.m__rooms-grid.grid .room-col .room .room-details').matchHeight();
	$('.m__interactive-map .intro-content.c__section-content').matchHeight();
	$('.m__interactive-map .details__top').matchHeight();
	/*$('.js__testimonial-match-height').matchHeight({
		byRow: false
	});*/

	// Local Area
	var tabContentHeight = $('.m__local-area .tab-content-row .tab-content.active').outerHeight();
	$('.m__local-area .tab-content-row').css('min-height', tabContentHeight + 'px');

	$('.m__local-area .tab').on('click', function (e) {
		e.preventDefault();

		if (!$(this).hasClass('active')) {
			$('.m__local-area .tab').removeClass('active');
			$(this).addClass('active');

			var tabContent = $(this).data('tab-content');

			$('.m__local-area .tab-content-row .tab-content').fadeOut();
			$('.m__local-area .tab-content-row .tab-content#' + tabContent).fadeIn();
		}
	});

	// Gallery
	$('.grid .grid-item .overlay-container').on('click', function () {
		var slideIndex = $(this).parents('.grid-item-col').index();
		// Check if screen size is larger than 767px
		if ($('.m__gallery .categories .category').css('text-align') == 'left') {
			// iPad and above
			var filterCount = 0;

			$('.m__gallery-grid .grid .grid-item').each(function () {
				var filteredSlideIndex = $(this).index();
			});

			// Show overlay once the slider has initialised
			$('.gallery-slider').on('init', function (event, slick) {
				$(window).trigger('resize');

				$('.m__gallery-lightbox').addClass('showing');

				$('.gallery-slider').find('.slick-list').attr('tabindex', 0).focus();
			});

			var arrow = '/wp-content/themes/vondelpark/library/images/icons/btn-arrow.svg';

			$('.gallery-slider').slick({
				initialSlide: slideIndex,
				arrows: true,
				nextArrow:
					"<div class='slick-arrow slick-next' style='background-image: url(" +
					arrow +
					");'></div>",
				prevArrow:
					"<div class='slick-arrow slick-prev' style='background-image: url(" +
					arrow +
					");'></div>",
				appendArrows: $('.gallery-slider-container'),
				dots: false,
				autoplay: false,
				adaptiveHeight: true,
				variableWidth: true,
			});
		} else {
			// mobile
		}
	});

	$('.m__gallery-lightbox .background, .controls .close-container .close-icon').on(
		'click',
		function () {
			$('.m__gallery-lightbox').removeClass('showing');
			$('.gallery-slider').slick('unslick');
		}
	);

	// Map Init
	if ($('#map').length) {
		initMap();
	}

	// Rooms page lightbox
	$('.js__lightbox-trigger').on('click', function (e) {
		e.preventDefault();

		var image = $(this).data('image');

		$('.lightbox .image-container img').attr('src', image);
		$('.lightbox').addClass('showing');
	});

	$('.js__close-lightbox').on('click', function (e) {
		$('.lightbox').removeClass('showing');
	});

	//Amenities Popup
	$('.js__amenities-trigger').on('click', function (e) {
		e.preventDefault();

		var roomID = $(this).data('room-id');
		var language = $(this).data('language');

		$.ajax({
			type: 'POST',
			dataType: 'html',
			url: main__js_vars.ajaxurl,
			data: {
				room_id: roomID,
				language: language,
				action: 'amenities_popup',
			},
			beforeSend: function () {
				$('.popup#amenities #amenities-grid').html('');
				$('.popup#amenities #amenities-grid').removeClass('loaded');
				$('.popup-wrapper').addClass('active');
				$('.popup#amenities').addClass('active');
			},
			success: function (data) {
				var dataReturned = JSON.parse(data);

				$('.popup#amenities #amenities-grid').html(dataReturned.output);
				$('.popup#amenities #amenities-grid').addClass('loaded');
			},
			error: function (jqXHR, textStatus, errorThrown) {
				console.log(jqXHR);
			},
		});
	});

	$('.js__popup-close').on('click', function (e) {
		e.preventDefault();

		$('.popup-wrapper').removeClass('active');
		$('.popup').removeClass('active');
	});

	// close the amenities modal/popup when ESC key is pressed
	var KEYCODE_ESC = 27;
	$(document).keyup(function (e) {
		if (e.keyCode == KEYCODE_ESC) $('.js__popup-close').click();
	});

	// Tooltips
	iconTooltipWidth();

	// ScrollDepth
	jQuery(function () {
		jQuery.scrollDepth();
	});

	// Fade-in-on-scroll anims
	scrollingAnimations();

	//Custom popup Check
	if ($('.custom-overlay').length > 0) {
		var checkCustomPopupCookie = getCookie('pp_custom_popup');
		if (checkCustomPopupCookie) {
			//Do nothing as they have the cookie
		} else {
			//Show the popup!
			$('.custom-overlay').addClass('active');

			setCookie('pp_custom_popup', 'popped', 1);
		}
	}
	$('.custom-overlay .close-button').click(function () {
		$('.custom-overlay').removeClass('active');
	});

	//Custom code to handle the default 'read more' option within the WYSIWYG field
	//Only used on the full width content area module atm
	//Also currently a little flawed as if there's multiple of these on a single page, clicking one opens all!
	//But don't judge i'm clearing tickets 😤
	$('.js__read-more-toggle').click(function () {
		$('.js__read-more-toggle').addClass('hide');
		$('.js__read-more-content').removeClass('hide');
	});

	// MeetingsPackage Code
	if ( document.getElementById('js-meeting-package-container') ) {
		var widgetID = document.getElementById('js-meeting-package-container').getAttribute('data-widget-id');
		var locationID = document.getElementById('js-meeting-package-container').getAttribute('data-location');
		var lang = document.getElementById('js-meeting-package-container').getAttribute('data-language');

		if (typeof existingScript === 'undefined') {
			let existingScript
		}
		if (typeof existingIframe === 'undefined') {
			let existingIframe
		}
		if (typeof scriptTag === 'undefined') {
			let scriptTag
		}
		existingScript = document.getElementById("mp_snippet_script")
		if (existingScript) {
		 	existingScript.remove()
		}
		existingIframe = document.getElementById("mp-bookingengine")
		if (existingIframe) {
			existingIframe.remove()
		}

		scriptTag = document.createElement('script')
		scriptTag.setAttribute('id', 'mp_snippet_script')
		scriptTag.setAttribute('type', 'text/javascript')
		scriptTag.setAttribute('src', 'https://bookingengine-mp.s3.eu-west-2.amazonaws.com/script_dynamic.js')
		scriptTag.setAttribute("async", true)
		scriptTag.setAttribute('langcode', lang)
		scriptTag.setAttribute('whitelabel_id', '288245')
		scriptTag.setAttribute('widget_id', widgetID)
		scriptTag.setAttribute('version', 'frontpage-v4')
		scriptTag.setAttribute('people', '10')
		scriptTag.setAttribute('destination', locationID);

		document.getElementById("mp-booking-engine-iframe-container").appendChild(scriptTag)			
	}

	// Create session storage for tracking params passed in URL
	setSessionStorageForTrackingParams();

	// Add tracking hidden input fields
	addTrackingElems();

	// Add tracking params to radisson URLs
	addTrackingParamsToRadissonUrls();
}

function setSessionStorageForTrackingParams() {
	const paramTypes = [
		'facilitatorId',
		'cid',
		'utm_source',
		'utm_medium',
		'utm_campaign',
		'utm_content',
		'utm_term',
	];
	const currentUrlParams = new URLSearchParams(window.location.search);

	paramTypes.forEach((param) => {
		if (currentUrlParams.has(param)) {
			var cookieVal = currentUrlParams.get(param).replaceAll(' ', '+');

			sessionStorage.setItem(param, cookieVal);
		}
	});
}

function getAbTestCookieData() {
	const cookies = document.cookie.split(';');
	let returnData = false;

	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i].trim();

		// Check if the cookie starts with the expected prefix
		if (cookie.indexOf('_vis_opt_exp_') === 0) {
			const [initial, prefix, opt, exp, campaignId, suffix] = cookie.split('_');

			// Check if the cookie structure matches
			if (suffix.indexOf('combi=') === 0) {
				const [name, value] = suffix.split('=');

				return {
					name: name,
					value: parseInt(value),
					campaignId: parseInt(campaignId),
				};
			}
		}
	}

	return false;
}

function addTrackingElems() {
	if (sessionStorage.facilitatorId) {
		var inputHTML =
			'<input type="hidden" name="facilitatorId" id="facilitatorId" value="' +
			sessionStorage.facilitatorId +
			'">';
		$('.js__booking-form-hidden-elements').append(inputHTML);
	}
	if (sessionStorage.cid) {
		var inputHTML =
			'<input type="hidden" name="cid" id="cid" value="' + sessionStorage.cid + '">';
		$('.js__booking-form-hidden-elements').append(inputHTML);
	}
	if (sessionStorage.utm_source) {
		var inputHTML =
			'<input type="hidden" name="utm_source" id="utm_source" value="' +
			sessionStorage.utm_source +
			'">';
		$('.js__booking-form-hidden-elements').append(inputHTML);
	}
	if (sessionStorage.utm_medium) {
		var inputHTML =
			'<input type="hidden" name="utm_medium" id="utm_medium" value="' +
			sessionStorage.utm_medium +
			'">';
		$('.js__booking-form-hidden-elements').append(inputHTML);
	}
	if (sessionStorage.utm_campaign) {
		var inputHTML =
			'<input type="hidden" name="utm_campaign" id="utm_campaign" value="' +
			sessionStorage.utm_campaign +
			'">';
		$('.js__booking-form-hidden-elements').append(inputHTML);
	}
	if (sessionStorage.utm_content) {
		var inputHTML =
			'<input type="hidden" name="utm_content" id="utm_content" value="' +
			sessionStorage.utm_content +
			'">';
		$('.js__booking-form-hidden-elements').append(inputHTML);
	}
	if (sessionStorage.utm_term) {
		var inputHTML =
			'<input type="hidden" name="utm_term" id="utm_term" value="' +
			sessionStorage.utm_term +
			'">';
		$('.js__booking-form-hidden-elements').append(inputHTML);
	}
}

function addTrackingParamsToRadissonUrls() {
	const paramTypes = [
		'facilitatorId',
		'cid',
		'utm_source',
		'utm_medium',
		'utm_campaign',
		'utm_content',
	];
	const currentUrlParams = new URLSearchParams(window.location.search);
	const radissonLinksNodeList = document.querySelectorAll('a[href*="radissonhotels.com"]');
	const radissonLinks = [...radissonLinksNodeList];

	radissonLinks.forEach((link) => {
		let href = link.getAttribute('href');

		paramTypes.forEach((param) => {
			if (!href.includes(param)) {
				let paramVal = false;
				if (currentUrlParams.has(param)) {
					// Check for param in query string
					paramVal = currentUrlParams.get(param);
				} else if (getCookie(param)) {
					// Check for param in cookies
					paramVal = getCookie(param);
				}

				if (paramVal && paramVal > '') {
					href = addParamToUrl(href, param, paramVal);
					link.setAttribute('href', href);
				}
			}
		});
	});
}

function addParamToUrl(url, param, value) {
	if (url.includes('?')) {
		const lastChar = url.charAt(url.length - 1);
		if (lastChar === '/') {
			const urlWithoutTrailingSlash = url.slice(0, -1);
			return `${urlWithoutTrailingSlash}&${param}=${value}`;
		}
		return `${url}&${param}=${value}`;
	}

	return `${url}?${param}=${value}`;
}


/* Fade in on scroll animation
 **************************************************/
function scrollingAnimations() {
	// Check if internet explorer and turn off scrolling animations if so.
	var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
	var msie = ua.indexOf('MSIE '); // IE 10 or older
	var trident = ua.indexOf('Trident/'); //IE 11

	if (msie > 0 || trident > 0) {
		// If IE 11 or older
		$('.js__hidden').removeClass('js__hidden');
		return;
	}

	// Add event listeners
	fadeInVisible();
	$(document).on('scroll', fadeInVisible);
	$(window).on('resize', fadeInVisible);

	// Function to check if element in viewport
	function isVisible(elem) {
		const scrollTop = $(window).scrollTop();

		const offsetTop = elem.offset().top;
		let topDist = offsetTop - window.innerHeight;

		// If element has top padding subtract it from the element's distance from top. This prevents elements with lots of top padding animating in too early.
		let topPadd = elem.css('padding-top');
		if (topPadd != '') {
			topPadd.replace('px', '');
			topPadd = parseInt(topPadd);
			topDist += topPadd;
		}

		// Add extra space to distance from top to delay animation slightly. Just for aesthetic purposes.
		const spacing = 80;
		topDist += spacing;

		// If element in viewport return true.
		if (scrollTop > topDist) {
			return true;
		} else {
			return false;
		}
	}

	// Check if element in viewport and animate in.
	function fadeInVisible() {
		// Get selectors to which the scroll animations will apply.
		const hidden = $('.js__hidden');

		hidden.each(function () {
			if (isVisible($(this)) == true) {
				$(this).addClass('js__visible');
			}
		});
	}
}

function setCookie(name, value, days) {
	var expires = '';
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toUTCString();
	}
	document.cookie = name + '=' + (value || '') + expires + '; path=/';
}
function getCookie(name) {
	var nameEQ = name + '=';
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}
function eraseCookie(name) {
	document.cookie = name + '=; Max-Age=-99999999;';
}

function ZoomControl(controlDiv, map) {
	google.maps.event.addDomListener(zoomout, 'click', function () {
		var currentZoomLevel = map.getZoom();
		if (currentZoomLevel != 0) {
			map.setZoom(currentZoomLevel - 1);
		}
	});

	google.maps.event.addDomListener(zoomin, 'click', function () {
		var currentZoomLevel = map.getZoom();
		if (currentZoomLevel != 21) {
			map.setZoom(currentZoomLevel + 1);
		}
	});
}

function initMap() {
	var mapLat = $('#map').data('lat');
	var mapLng = $('#map').data('lng');
	var location = { lat: mapLat, lng: mapLng };

	var map = new google.maps.Map(document.getElementById('map'), {
		zoom: 16,
		center: location,
		mapTypeControl: false,
		fullscreenControl: false,
		streetViewControl: false,
		zoomControl: false,
	});

	/*var marker = new google.maps.Marker({
		position: location,
		map: map,
		icon: '/wp-content/themes/vondelpark/library/images/icons/marker.png',
	});*/

	var marker = new google.maps.Marker({
		position: location,
		map: map,
		icon: '/wp-content/themes/county_hall/library/images/icons/marker.png',
	});

	/* Create the DIV to hold the control and call the ZoomControl() constructor passing in this DIV. */
	var customZoomDiv = document.createElement('div');
	var customZoom = new ZoomControl(customZoomDiv, map);
}

function iconTooltipWidth() {
	var tooltip = $('.icon-tooltip');

	tooltip.each(function () {
		var tooltipText = $(this).text();
		var tooltipLength = tooltipText.length;
		var width = 10 * tooltipLength;

		$(this).css('width', width + 'px');
	});
}


if ( $('#interactive-map').length ) {
	initInteractiveMap();
}

/* interactive map init */
function initInteractiveMap() {
	var mapLat = $('#interactive-map').data('lat');
	var mapLng = $('#interactive-map').data('lng');
	var location = {lat: mapLat, lng: mapLng};
	var ppheMarker = $('#interactive-map').data('icon');
	var ppheTitle = $('#interactive-map').data('title');
	var ppheMapLink = $('#interactive-map').data('google-listing');

	var map = new google.maps.Map(document.getElementById('interactive-map'), {
		zoom: 16,
		center: location,
		mapTypeControl: true,
		fullscreenControl: false,
		streetViewControl: false,
		zoomControl: false	,
		styles: [
			{
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#f5f5f5"
					}
				]
			},
			{
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#122339"
					}
				]
			},
			{
				"elementType": "labels.text.stroke",
				"stylers": [
					{
						"color": "#f5f5f5"
					}
				]
			},
			{
				"featureType": "administrative.land_parcel",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#bdbdbd"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#eeeeee"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#757575"
					}
				]
			},
			{
				"featureType": "poi.park",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#e5e5e5"
					}
				]
			},
			{
				"featureType": "poi.park",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#9e9e9e"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#ffffff"
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#757575"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#dadada"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#616161"
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#9e9e9e"
					}
				]
			},
			{
				"featureType": "transit.line",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#e5e5e5"
					}
				]
			},
			{
				"featureType": "transit.station",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#eeeeee"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#c9c9c9"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#9e9e9e"
					}
				]
			}
		]
	});

	// Hotel Marker
	marker = new google.maps.Marker({
		position : new google.maps.LatLng(mapLat, mapLng),
		map : map,
		animation : google.maps.Animation.DROP,
		icon: { url : ppheMarker, scaledSize : new google.maps.Size(40, 55)},
	});

	// Hotel Marker Hover Event
	google.maps.event.addListener(marker, 'mouseover', (function (marker, i) {
		return function () {
			infowindow.setContent(ppheTitle);
			infowindow.open(map, marker);
		}
	})(marker, i));

	// Hotel Marker Click Event
	google.maps.event.addListener(marker, 'click', function() {
		window.open(ppheMapLink, '_blank');
	})


	/* Attractions */

	var aItems = $('.attraction-item');
	var  itemsData = [];


	$(aItems).each(function(aItem){

		var compile = {
			"title" 					 : $(this).data('title'),
			"text"  					 : $(this).data('text'),
			"walking_distance" : $(this).data('walking-distance'),
			"directions"			 : $(this).data('directions'),
			"lat"   					 : $(this).data('lat'),
			"long"  					 : $(this).data('long'),
			"icon"  					 : $(this).data('icon'),
			"id"    					 : $(this).data('marker-id'),
		};

		itemsData.push(compile);

	});


	var infowindow = new google.maps.InfoWindow();
	var marker, i;

	for (i = 0; i < itemsData.length; i++) {

		console.log(itemsData[i]);
		marker = new google.maps.Marker({

			position: new google.maps.LatLng(itemsData[i].lat, itemsData[i].long),
			map: map,
			animation: google.maps.Animation.DROP,
			icon: {url:itemsData[i].icon , scaledSize: new google.maps.Size(50, 50)},

		});


		google.maps.event.addListener(marker, 'click', (function (marker, i) {
			return function () {
				$(aItems).removeClass('active');
				$('html, body').animate({
					scrollTop: $('#' + itemsData[i].id).offset().top - 130,
				}, 1250);
				$('#' + itemsData[i].id).addClass('active');

			}
		})(marker, i));

		google.maps.event.addListener(marker, 'mouseover', (function (marker, i) {
			var contentString = itemsData[i].title + '<br>';
			contentString += itemsData[i].walking_distance + '<br>';
			contentString += '<a href="' + itemsData[i].directions + '" target="_blank">Directions</a>';

			return function () {
				infowindow.setContent(contentString);
				infowindow.open(map, marker);
			}
		})(marker, i));
	}


	/* Create the DIV to hold the control and call the ZoomControl() constructor passing in this DIV. */
	var customZoomDiv = document.createElement('div');
	var customZoom = new ZoomControl(customZoomDiv, map);
}

document.addEventListener('DOMContentLoaded', function() {
    const selectors = document.querySelectorAll('.c-language-selector');

	if ( selectors ) {
		selectors.forEach(selector => {
			const currentLanguage = selector.querySelector('.c-language-selector__current-lang');

			if ( selector.classList.contains('c-language-selector--mobile') ) {
				const overlay = document.querySelector('.c-language-selector-overlay');

				if ( overlay ) {
					const form = overlay.querySelector('.c-language-selector-overlay__form');
	
					currentLanguage.addEventListener('click', function(event) {
						document.querySelector('.m__header').classList.add('d-none');
						overlay.classList.add('show');
					});
	
					if ( form ) {
						form.addEventListener('submit', function(event) {
							event.preventDefault();
							
							const translationUrl = form.querySelector('select').value;
		
							window.location.href = translationUrl;
						});
					}

					const closeBtn = overlay.querySelector('.c-language-selector-overlay__close');
	
					if ( closeBtn ) {
						closeBtn.addEventListener('click', function(event) {
							overlay.classList.remove('show');
							document.querySelector('.m__header').classList.remove('d-none');
						});
					}
				}
			} else {
				currentLanguage.addEventListener('click', function(event) {
					event.stopPropagation();
					selector.classList.toggle('open');
				});
			
				document.addEventListener('click', function(event) {
					if (!event.target.closest('.c-language-selector')) {
						selector.classList.remove('open');
					}
				});
			}
		});
	}

});

// Get slide Param from URL
function getSlideIndexFromURL() {
	const urlParams = new URLSearchParams(window.location.search);
	const slideIndex = urlParams.get('slide');
	return slideIndex ? parseInt(slideIndex) - 1 : 0; // Convert to zero-based index
}

function appendLinksWithGclid() {
	const links = document.querySelectorAll('a');

	if ( links ) {		
		const domain = main__js_vars.domain;
	
		links.forEach((link) => {
			if (link.href.includes(domain) && !link.href.includes('gclid') && link.getAttribute('target') == '_blank') {
				addGclidToLink(link);
			}
		});
	}
}

function appendRadissonLinksWithGclid() {
	const links = document.querySelectorAll('a[href*="radissonhotels.com"]');

	if ( links ) {
		links.forEach((link) => {
			addGclidToLink(link);
		});
	}
}

function addGclidToLink(link) {
	// Get all url parameters for this link
	const urlParams = new URLSearchParams(link.href.split('?')[1]);
					
	// Get the gclid from sessionStorage
	const gclid = sessionStorage.getItem('gclid');

	if (gclid) {
		// If the link already has parameters, add gclid with & else add gclid with ?
		link.href += urlParams.toString() ? `&gclid=${gclid}` : `?gclid=${gclid}`;
	}
}

function getGclidParameter() {
	const urlParams = new URLSearchParams(window.location.search);
	const gclid = urlParams.get('gclid');

	// If the gclid parameter exists, add it to the session storage
	if (gclid) {
		sessionStorage.setItem('gclid', gclid);
	}
}